export default __webpack_public_path__ + "images/8I.0486394.png";